import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PopupWrapper } from "../../../../../components/popupWrapper";
import { ReactComponent as Close } from "../../../../../assets/close.svg";
import Button from "../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../components/button/types";
import "./index.css";

const AddCreditsModal = ({
  isOpen,
  onClose,
  onAddCredits,
  availableCredits,
  creditsIncrements,
  successfullyAdditionalCredits,
}: any) => {
  const [selectedCredits, setSelectedCredits] = useState<number | null>(null);
  const { t } = useTranslation("myArea");

  const handleSubmit = () => {
    if (
      selectedCredits !== null &&
      selectedCredits > 0 &&
      selectedCredits <= availableCredits
    ) {
      onAddCredits(selectedCredits);
    }
  };

  return (
    <PopupWrapper isOpen={isOpen}>
      <div className="bg-white bg-opacity-100  md:w-1/3 w-1/2 p-5 rounded-lg">
        {successfullyAdditionalCredits ? (
          <div>
               {t("credits.additional-credits-success-message")}
             
          </div>
        ) : (
          <>
            <div className="flex mb-4 justify-between items-center text-lg font-bold">
              <div className="w-10/12">{t("credits.add-credits-title")}</div>
              <div className="flex justify-center w-2/12">
                <Close className="cursor-pointer" onClick={onClose} />
              </div>
            </div>
            <p className="text-sm text-Grey-dark mb-4">
              {t("credits.add-credits-description")}
            </p>
            <div className="mb-6">
              {creditsIncrements.map((credit: any) => (
                <div
                  key={credit.value}
                  className={`flex items-center mb-2 ${
                    credit.value > availableCredits ? "text-gray-400" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="credits"
                    value={credit.value}
                    onChange={(e) => setSelectedCredits(Number(e.target.value))}
                    disabled={credit.value > availableCredits}
                    className="custom-radio-button mr-2"
                  />
                  <span>
                    {`${credit.value} ${t(
                      `credits.add-credits-word.${
                        credit.value === 1 ? "credit" : "credits"
                      }`
                    )} (${credit.minutes} ${t(
                      "credits.add-credits-word.minutes"
                    )})`}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex justify-between">
              <Button
                className="w-full mr-2"
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.MEDIUM}
                onClick={onClose}
              >
                {t("credits.cancel-button")}
              </Button>
              <Button
                className="w-full ml-2"
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.MEDIUM}
                onClick={handleSubmit}
                disabled={
                  selectedCredits === null || selectedCredits > availableCredits
                }
              >
                {t("credits.add-credits-submit-button")}
              </Button>
            </div>
          </>
        )}
      </div>
    </PopupWrapper>
  );
};

export default AddCreditsModal;
